<template lang="pug">
  .column.width-100
    label.text-normal.m4-bottom-05(v-if='label') {{ label }}
    .input-container.row.wrap
      .tag.row.middle.m-right-1(v-for='tag in tags' :key='tag.id || tag.temporalId')
        span.tag-label.dark-gray.text-normal
          | {{  tag.description }}
        button(@click='$emit("deleteTag", tag.temporalId || tag.id)' type='button')
          simple-svg.svg-icon.dark-gray-icon(:filepath='crossIcon' :width='"12px"' :height='"12px"')
      input.text-normal.tag-material-input.item-1(
        type='text'
        autocomplete="off"
        :value='newTag'
        @keydown.enter='addTag'
        @keydown.delete='pressDelete'
        v-click-outside='clickOutside'
        @input='editTag'
        :placeholder='!tags.length ? placeholder : ""'
      )
    .row(v-if='showMaxTagsError')
      simple-svg.red-icon.m4-right-2.red-stroke-icon(:filepath='errorIcon' :width='"16px"' :height='"16px"')
      span.error-desc
        | {{ $t('common.wordsLimitReached') }}
    .row.top.m4-left-1(v-if='showError')
      simple-svg.error-icon.red-icon.m4-right-2.red-stroke-icon(:filepath='errorIcon' :width='"16px"' :height='"16px"')
      span.text-small.red
        | {{ errorMessage }}
</template>

<script>
import errorIcon from '@/assets/ic_stop.svg'
import inputValidation from '@/mixins/inputsValidationMixin'
import crossIcon from '@/assets/ic_cross.svg'
import uniqid from 'uniqid'
import ClickOutside from 'vue-click-outside'

export default {
  directives: { ClickOutside },
  mixins: [inputValidation],
  props: {
    name: { type: String },
    label: { type: String },
    tags: { type: Array, required: true, default: () => [] },
    placeholder: { type: String },
    maxTags: { type: Number, default: 10 },
    errorMessage: { type: String },
    materialType: { type: Number },
    necessaryMaterialType: { type: Number }
  },
  data() {
    return {
      crossIcon,
      errorIcon,
      newTag: '',
      showMaxTagsError: false
    }
  },
  methods: {
    editTag(evt) {
      this.newTag = evt.target.value
    },
    addTag() {
      this.showMaxTagsError = false
      if (this.tags.length > this.maxTags) {
        this.showMaxTagsError = true
        return
      }
      this.$emit('addTag', {
        description: this.newTag.trim(),
        materialType: this.materialType,
        necessaryMaterialType: this.necessaryMaterialType,
        temporalId: uniqid()
      })
      this.newTag = ''
    },
    clickOutside() {
      if (this.newTag.length) this.addTag()
    },
    pressDelete() {
      if (this.newTag) return
      const lastTag = this.tags[this.tags.length - 1]
      this.$emit('deleteTag', lastTag.temporalId || lastTag.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/scss/variables/_colors";

.input-container {
  margin-top: 8px;
  border: 1px solid $light-gray;
  border-radius: 6px;
  height: 40px;
  min-height: 40px;
  height: auto;
  padding: 0;
}

.tags{
  flex-wrap: wrap;
}
.tag{
  background-color: $light-gray;
  border-radius: 5px;
  height: 30px;
  margin: 4px;
  padding: 4px 15px;
  .tag-label {
    margin-right: 15px;
  }
  .svg-icon {
    line-height: 0;
  }
}

.tag-material-input {
  min-height: initial;
  padding: 8px;
  border-radius: 6px;
  min-width: 150px;
}
</style>
